const SHORTS_SRP_ROUTES = new Set(['PropertiesListing']);

export function useShortsSrp() {
	const route = useRoute();

	// Shorts is the SRP default; shared listings keep their own behavior.
	const isShortsSrpEnabled = computed(() =>
		SHORTS_SRP_ROUTES.has(String(route.name))
	);

	return { isShortsSrpEnabled };
}
